import React, { useEffect, useState } from 'react';

import { Visibility, VisibilityOff } from '@mui/icons-material';
import { Link, IconButton, InputAdornment, FormControlLabel, Alert } from '@mui/material';
import { formatString } from '../../utils/numbers';
import PasswordStrengthBar from 'react-password-strength-bar';

// Material Ui
import { Grid, TextField } from '@mui/material';

import { useForm, Controller } from 'react-hook-form';
import CircularSpinner from '../UI/Progress/CircularSpinner';
import { FooterText, AuthContainer, LoginTitle } from './Login.styles';
import { RegisterButton } from './Register.styles';
import { IOSSwitch } from '../UI/IosSwitch';
import { useNavigate } from 'react-router';

export default function RegisterTeacherForm({
	onInputChange,
	handleRegister,
	error,
	updateError,
	isStatusMessage,
	buttonLoading
}) {
	const navigate = useNavigate();
	const [showPassword, setShowPassword] = useState(false);
	const [passwordStrength, setPasswordStrength] = useState('');
	const { handleSubmit, control } = useForm();

	const handleClickShowPassword = () => {
		setShowPassword(!showPassword);
	};

	const handleMouseDownPassword = (event) => {
		event.preventDefault();
	};

	useEffect(
		() => () => {
			updateError(null);
		},
		[updateError]
	);

	return (
		<AuthContainer>
			{error ? (
				<Alert severity="error" sx={{ mt: 1, mb: 1 }}>
					{formatString(`<p style="margin:0">${error}</p>`)}
				</Alert>
			) : null}
			{!isStatusMessage && <LoginTitle variant="h4">Devino profesor!</LoginTitle>}
			<Grid container>
				<form
					onSubmit={handleSubmit(() => {
						handleRegister();
					})}
				>
					<Grid container spacing={1}>
						<Grid item xs={12} sm={6} md={6}>
							<Controller
								control={control}
								name="LastName"
								render={({ field: { onChange, onBlur, value, ref } }) => (
									<TextField
										margin="dense"
										onChange={onInputChange}
										name="lastName"
										required
										fullWidth
										id="lastName"
										label="Nume"
										variant="outlined"
									/>
								)}
							/>
						</Grid>
						<Grid item xs={12} sm={6} md={6}>
							<Controller
								control={control}
								name="FirstName"
								render={({ field: { onChange, onBlur, value, ref } }) => (
									<TextField
										onChange={onInputChange}
										name="firstName"
										required
										fullWidth
										id="firstName"
										label="Prenume"
										margin="dense"
										variant="outlined"
									/>
								)}
							/>
						</Grid>
						<Grid item xs={12}>
							<Controller
								control={control}
								name="Email"
								render={({ field: { onChange, onBlur, ref } }) => (
									<TextField
										required
										fullWidth
										id="email"
										type="email"
										label="Adresa de e-mail"
										name="email"
										onChange={onInputChange}
										margin="dense"
										variant="outlined"
									/>
								)}
							/>
						</Grid>
						<Grid item xs={12}>
							<Controller
								control={control}
								name="Password"
								render={({ field: { onChange, onBlur, value, ref } }) => (
									<TextField
										required
										fullWidth
										name="password"
										label="Parola"
										type={showPassword ? 'text' : 'password'}
										id="password"
										InputProps={{
											minLength: '8',
											endAdornment: (
												<InputAdornment position="end">
													<IconButton
														aria-label="toggle password visibility"
														onClick={handleClickShowPassword}
														onMouseDown={handleMouseDownPassword}
														edge="end"
													>
														{showPassword ? <Visibility /> : <VisibilityOff />}
													</IconButton>
												</InputAdornment>
											)
										}}
										onChange={(e) => {
											onInputChange(e);
											setPasswordStrength(e.target.value);
										}}
										margin="dense"
									/>
								)}
							/>
							<PasswordStrengthBar
								password={passwordStrength}
								shortScoreWord=""
								scoreWords={[
									'Parola ta este slabă. Se recomandă cel puțin 8 caractere, inclusiv numere și simboluri.',
									'Parola ta este slabă. Se recomandă cel puțin 8 caractere, inclusiv numere și simboluri.',
									'Parola ta este sigură.',
									'Parola ta este sigură.',
									'Parola ta este foarte sigură.'
								]}
							/>
						</Grid>
						<Grid item xs={12}>
							<Controller
								control={control}
								name="repeatPassword"
								render={({ field: { onChange, onBlur, ref } }) => (
									<TextField
										required
										fullWidth
										name="confirmPassword"
										label="Confirma Parola"
										type={showPassword ? 'text' : 'password'}
										id="repeatPassword"
										InputProps={{
											minLength: '8',
											endAdornment: (
												<InputAdornment position="end">
													<IconButton
														aria-label="toggle password visibility"
														onClick={handleClickShowPassword}
														onMouseDown={handleMouseDownPassword}
														edge="end"
													>
														{showPassword ? <Visibility /> : <VisibilityOff />}
													</IconButton>
												</InputAdornment>
											)
										}}
										onChange={onInputChange}
										margin="dense"
									/>
								)}
							/>
						</Grid>

						<Grid item xs={12}>
							<FormControlLabel
								name="termsandconditions"
								control={<IOSSwitch sx={{ m: 1 }} />}
								label={formatString(
									'<p style="margin:0; text-aligment:justify">Accept termenii şi condițiile de utilizare ale platformei.</p><a href="https://admiterepolitie.ro/termeni-si-conditii">Află mai multe aici.</a>'
								)}
							/>
						</Grid>
					</Grid>

					<RegisterButton fullWidth type="submit" variant="contained" disabled={buttonLoading}>
						{buttonLoading ? <CircularSpinner size={20} /> : 'Inregistrează-te'}
					</RegisterButton>

					<FooterText>
						Ai deja un cont?{' '}
						<Link
							component="button"
							underline="always"
							color="primary"
							onClick={() => {
								navigate('/login');
							}}
						>
							Autentifică-te
						</Link>
					</FooterText>
				</form>
			</Grid>
		</AuthContainer>
	);
}
